import BossModel from "@/models/BossModel";
import PlatinumPage from "@/models/PlatinumPage/PlatinumPage";

export default class PlatinumRoute extends BossModel {

    static apiUrl = 'platinum-route';

    static entity = 'platinumRoutes';

    static fields() {
		return {
			id: this.number(null).nullable(),
			url: this.attr(null),
            routeable_type: this.attr(null),
            routeable_id: this.number(null).nullable(),
            action: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            meta_title_nl: this.attr(null),
            meta_title_en: this.attr(null),
            meta_description_nl: this.attr(null),
            meta_description_en: this.attr(null),
            is_no_index: this.boolean(null),
            is_no_follow: this.boolean(null),
            canonicle_platinum_route_id: this.number(null).nullable(),
            canoniclePlatinumRoute: this.belongsTo(this, 'canonicle_platinum_route_id'),
            platinum_page: this.belongsTo(PlatinumPage, 'platinum_route_id'),
        }
	}

    static findByRouteable(routeableId, routeableType) {
        return this.all().find(item => item.routeable_id === routeableId && item.routeable_type === routeableType);
    }

    static fetchWithReferences(id) {
        return this.api().with([
            'routeable',
        ]).appended(['connectedCount']).find(id, false);
    }

    static search(params = {}) {
        return this.api()
            .filtered(params.filters)
            .limit(50)
            .ordered({'url': 'asc'})
            .get().then((data) => {
            let instances = [];
            for (let key in data) {
                instances.push(new PlatinumRoute(data[key]));
            }
            return instances;
        });
    }

    static get(filters = {}) {
        return this.api()
            .filtered(filters)
            .limit(0)
            .ordered({url:'asc'})
            .appended(['childrenCount'])
            .get();
    }

    static getWithParents(filters = {}) {
        return this.api().action('with_parents')
            .filtered(filters)
            .limit(0)
            .ordered({url:'asc'})
            .appended(['childrenCount'])
            .get();
    }

    GetLevel() {
        return (this.url.match(/\//g) || []).length;
    }

    LastUrlPart() {
        return this.url.substr(this.url.lastIndexOf('/') + 1);
    }

    IsPublished() {
        return this.url !== null;
    }

    IsParentFrom(activePlatinumRoute) {
        return activePlatinumRoute.url.startsWith(this.url + '/');
    }

    IsChildFrom(activePlatinumRoute) {
        return this.url.startsWith(activePlatinumRoute.url + '/') && this.GetLevel() === activePlatinumRoute.GetLevel() + 1;
    }
}
